import React from 'react';
import './fieldstyle.css'

const FieldGenerico = ({ input, label, readonly, max, disabled, placeholder, type, mayusculas,func_OnBlur, meta: { touched, error, invalid, warning } }) => (
  <div className={`grupo-form ${touched && invalid ? 'tiene-error' : ''}`}>
    <label className='label-control'>{label}</label>
    <div>
      <input {...input} className={'control' + (mayusculas?' mayusculas':'')} placeholder={placeholder} 
        type={type} readOnly={readonly || false} disabled={disabled || false} autoComplete='off' onBlur={func_OnBlur}
         maxLength={max}/>
      <div className='descrip-error'>
      {touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
      </div>
    </div>
  </div>
)
export default FieldGenerico